/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Former goog.module ID: Blockly.Themes

import {Classic} from './classic.js';
import {Zelos} from './zelos.js';

export {Classic, Zelos};
